import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <Contact data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}